import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHDepartamentoDel = async (credentials, data) => {
    const body = {
        service: "RNHDepartamentoDel",
        params: {
            rnhDepartamentoId: data?.id || null,
            rnhDepartamentoVersion: data?.version ?? null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
